"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCurrencyFieldSetting = exports.isActionModel = void 0;
/**
 * Type guard for ActionModel
 */
function isActionModel(actions) {
    return Array.isArray(actions) && !!actions.length && 'Name' in actions[0];
}
exports.isActionModel = isActionModel;
/**
 * Type guard to check if the setting is a CurrencyFieldSetting
 * @param {FieldSetting} fieldSetting
 * @returns {fieldSetting is CurrencyFieldSetting}
 */
function isCurrencyFieldSetting(fieldSetting) {
    return Object.prototype.hasOwnProperty.call(fieldSetting, 'Format') || fieldSetting.Type === 'CurrencyFieldSetting';
}
exports.isCurrencyFieldSetting = isCurrencyFieldSetting;
//# sourceMappingURL=type-guards.js.map